<template>
  <el-form label-position='top'>
    <layout-card-wrap hasHeaderSlot
      v-loading="loading">
      <template slot="title">商品信息</template>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="商品名称:"> {{product.productName}} <span v-if="product.productNameRemark"> ({{product.productNameRemark}})</span> </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商品类型:"> {{product.categoryName}} </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="贸易类型:"> {{product.tradeType | tradeType()}} </el-form-item>
        </el-col>
        <el-col :span="8"  v-if="!userPermission.SUPERVISE">
          <el-form-item label="标签类型:" > {{product.tagType | tagType()}} </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
        <el-form-item label="赋码方式:"> {{product.codingType | codingType()}} </el-form-item>
      </el-col> -->
      </el-row>
    </layout-card-wrap>
  </el-form>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'product-info',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    })
  }
}
</script>
